import axios from "axios";
import { ApiUrl } from "./ApiUrl";

export const VehicleSeat = (carId: number) => {
  return axios
    .request({
      method: "GET",
      url: `${ApiUrl}/vehicleTypes/${carId}`,
    })
    .then((res) => {
      return res.data.seaters;
    })
    .catch((e) => {});
};

export const VehicleBags = (carId: number) => {
  return axios
    .request({
      method: "GET",
      url: `${ApiUrl}/vehicleTypes/${carId}`,
    })
    .then((res) => {
      return res.data.bags;
    })
    .catch((e) => {});
};

export const VehiclePrice = (carId: number) => {
  return axios
    .request({
      method: "GET",
      url: `${ApiUrl}/vehicleTypes/${carId}`,
    })
    .then((res) => {
      return res.data.price;
    })
    .catch((e) => {});
};

export const VehicleSurcharge = (carId: number) => {
  return axios
    .request({
      method: "GET",
      url: `${ApiUrl}/vehicleTypes/${carId}`,
    })
    .then((res) => {
      return res.data.surcharge;
    })
    .catch((e) => {});
};
